import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IClientDetails, ClientField } from 'src/types/client/clients';

interface ClientResponse {
  data: {
    clientDetails: IClientDetails;
  };
}
@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})

export class ClientDetailsComponent implements OnInit {
  @Input() clientID: string = '';
  clientDetails!:IClientDetails;
  displayLoader: boolean = true;
  
  clientFields: ClientField[] = [
    { name: 'namePrefix', label: 'Title', type: 'select', placeholder: 'Select Title' },
    { name: 'firstName', label: 'First Name', placeholder: 'Your First Name' },
    { name: 'lastName', label: 'Last Name', placeholder: 'Your Last Name' },
    { name: 'occupation', label: 'Job Title', placeholder: 'Your Occupation' },
    { name: 'email', label: 'Email', placeholder: 'Your Email' },
    { name: 'mobile', label: 'Mobile Phone', placeholder: 'Mobile' }
  ];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.fetchClientDetails()
  }

fetchClientDetails() {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/GetClient?clientId=${this.clientID}`;
    this.http.get<ClientResponse>(url).subscribe({
      next: (response) => {
        this.clientDetails = response.data.clientDetails;
        this.displayLoader = false;
      },
      error: (error) => {
        console.error('Error updating client status:', error);
        this.displayLoader = false;
      }
    });
  }
  getFieldValue(field: ClientField): any {
    return this.clientDetails[field.name];
  }

}
